import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    loadingText: String
  }

  connect() {
    this.originalText = this.element.textContent.trim()
  }

  click() {
    this.element.disabled = true
    const loadingText = this.loadingTextValue || "Loading..."
    this.element.textContent = loadingText
  }
}